import React from "react";
import { useTheme, Select, MenuItem, ListItemIcon, Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useClasses = makeStyles()((theme, _params, classes) => {
  return {
    styledSelectStartIcon: {
      minWidth: theme.spacing(3)
    },
    styledSelectButton: {
      background: theme.palette.background.paper
    },
    styledSelectMenuItem: {
      "&:hover": {
        backgroundColor: "unset",
        color: theme.palette.primary.main,
        "& .MuiListItemIcon-root": {
          color: theme.palette.primary.main
        }
      },
      "&[aria-selected=true]": {
        backgroundColor: "unset !important",
        color: theme.palette.primary.main,
        [`& > .${classes.styledSelectConfirmIcon}`]: {
          display: "block !important",
          width: theme.spacing(3.5),
          paddingLeft: theme.spacing(1.5)
        },
        [`& > .${classes.styledSelectStartIcon}`]: {
          color: `${theme.palette.primary.main} !important`
        }
      }
    },
    styledSelectConfirmIcon: {
      display: "none",
      marginLeft: "auto"
    },
    styledSelectMenu: {
      maxHeight: theme.custom.styledSelectMenuMaxHeight
    },
    styledSelectIcon: {
      color: theme.palette.secondary.main
    },
    styledSelectMenuAlignLeft: {
      marginLeft: 0
    }
  };
});
class StyledSelectProps {
  options;
  dropdownClassName;
  alignLeft;
  iconClassName;
}
const StyledSelect = (props) => {
  const theme = useTheme();
  const { options, dropdownClassName, alignLeft, onOpen, onClose, open, MenuProps, ...selectProps } = props;
  const { classes, cx } = useClasses();
  const [icon, setIcon] = React.useState(getIcon(open));
  const iconComponent = () => /* @__PURE__ */ React.createElement(Box, { component: "span", className: cx(props.iconClassName, classes.styledSelectIcon, icon), fontSize: 10 });
  function handleOpen(e) {
    onOpen?.(e);
    setIcon(getIcon(true));
  }
  function handleClose(e) {
    onClose?.(e);
    setIcon(getIcon(false));
  }
  function getIcon(open2) {
    return open2 ? CustomIcon.ArrowUp : CustomIcon.ArrowDown;
  }
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      IconComponent: iconComponent,
      ...selectProps,
      MenuProps: {
        anchorOrigin: MenuProps?.anchorOrigin ?? {
          vertical: "bottom",
          horizontal: alignLeft ? "left" : "center"
        },
        transformOrigin: MenuProps?.transformOrigin ?? {
          vertical: "top",
          horizontal: alignLeft ? "left" : "center"
        },
        className: cx(dropdownClassName, classes.styledSelectMenu),
        classes: {
          paper: cx(alignLeft && classes.styledSelectMenuAlignLeft, dropdownClassName)
        },
        // The default zIndex has been changed to display the Drawer above the burger menu
        style: { zIndex: theme.zIndex.tooltip }
      },
      "data-testid": "styledSelect",
      inputProps: { "data-testid": "selectInput" },
      className: classes.styledSelectButton,
      onOpen: handleOpen,
      onClose: handleClose
    },
    options.map((o) => /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        className: classes.styledSelectMenuItem,
        disabled: o.disabled,
        key: o.value,
        value: o.value
      },
      o.startIcon ? /* @__PURE__ */ React.createElement(ListItemIcon, { className: classes.styledSelectStartIcon }, /* @__PURE__ */ React.createElement(Box, { component: "span", className: o.startIcon, fontSize: 10 })) : null,
      /* @__PURE__ */ React.createElement(LocalizedText, { label: o.label }),
      /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.Confirm, color: IconColor.Primary, className: classes.styledSelectConfirmIcon })
    ))
  );
};
export {
  StyledSelect,
  StyledSelectProps
};
//# sourceMappingURL=StyledSelect.js.map
